export enum CardioPerfectEthnicGroup {
    americanIndian = 'americanIndian',
    asian = 'asian',
    black = 'black',
    caucasian = 'caucasian',
    hispanic = 'hispanic',
    other = 'other',
    unknown = 'unknown',
}
